import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy, NgZone } from '@angular/core';
export interface Config {
  ApiUrl: string;
  ResourceUri: string;
  ResourceScope: string;
  ClientId: string;
  Authority: string;
  SignUpAuthority: string;
  ResetPasswordAuthority: string;
  EditProfileAuthority: string;
  ChangePasswordAuthority: string;
  CacheLocation: string;
  RedirectUri: string;
  RedirectUriForAquireToken: string;
  RedirectUriForSignUp: string;
  RedirectUriForForgotPassword: string;
  PostLogoutRedirectUri: string;
}

@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {
  isOnline: boolean = navigator.onLine;
  wasOnline: boolean = this.isOnline;
  public config: Config;
  private http: HttpClient;

  constructor(private readonly httpHandler: HttpBackend,
  )
    {
    this.http = new HttpClient(httpHandler);
  }

  loadConfig() {
    return this.http
      .get<Config>('./../../../assets/config.json')
      .toPromise()
      .then(config => {
        this.config = config;
      });
  }
}
